import { Capacitor } from '@capacitor/core';

/**
 * Platform Detection Utilities
 * 
 * Utility functions for detecting the current platform and environment
 */

/**
 * Check if the app is running in a native environment
 * @returns {boolean} True if running in native app
 */
export const isNative = () => Capacitor.isNativePlatform();

/**
 * Check if the app is running in a web browser
 * @returns {boolean} True if running in browser
 */
export const isWeb = () => !Capacitor.isNativePlatform();

/**
 * Get the current platform
 * @returns {string} Platform name ('ios', 'android', 'web')
 */
export const getPlatform = () => Capacitor.getPlatform();

/**
 * Check if running on iOS
 * @returns {boolean} True if iOS platform
 */
export const isIOS = () => getPlatform() === 'ios';

/**
 * Check if running on Android
 * @returns {boolean} True if Android platform
 */
export const isAndroid = () => getPlatform() === 'android';
/**
 * Check if running on iOS native environment
 * @returns {boolean} True if iOS native
 */
export const isIosNative = () => isIOS() && isNative();

/**
 * Check if running on Android native environment
 * @returns {boolean} True if Android native
 */
export const isAndroidNative = () => isAndroid() && isNative();


/**
 * Check if running on any mobile platform
 * @returns {boolean} True if iOS or Android
 */
export const isMobile = () => isIOS() || isAndroid();
